<template>
  <div class="user_page">
    <div class="admin_main">
      <div class="admin_container">
        <div class="division_main">
          <div class="d-flex justify-lg-end">
            <VBtn class="mb-3" color="primary" @click="downloadProductList">{{
              $t("downloadProductList")
            }}</VBtn>
          </div>
          <table-with-filter
            fixed-header
            :headers="headersWithTranslate"
            :items="items"
            :options.sync="configuration.options"
            hide-default-footer
            @update:sort="getProductItemsBySort"
            :page="configuration.pagination.page"
          >
            <template #filter.contractCode>
              <CustomInputText
                clearable
                v-model="ourProductFilter.contractNumb"
                @input="getProductItemsByFilter"
                class="no-margin user_input"
              ></CustomInputText>
            </template>
            <template #filter.accountingCode>
              <CustomInputText
                clearable
                v-model="ourProductFilter.accountingCode"
                @input="getProductItemsByFilter"
                class="no-margin user_input"
              ></CustomInputText>
            </template>
            <template #filter.orderedDepartmentsName>
              <vue-select
                v-if="$can($permissions['SEE_ALL_PRODUCTS_IN_WAREHOUSE'])"
                @input="getProductItemsByFilter"
                infinite
                clearable
                @item-resolved="setDepartment"
                @next-page-resolved="
                  (data) => setDepartment([...departments, ...data])
                "
                :get-item-promise="
                  ({ text, page }) =>
                    $store.dispatch('getDepartments', {
                      page,
                      name: text,
                      limit: 15,
                    })
                "
                v-model="ourProductFilter.orderedDepartmentId"
                :items="departments"
                class="product-select-in-modal"
              ></vue-select>
            </template>
            <template #filter.warehouseName>
              <vue-select
                v-if="$can($permissions.SEE_ALL_PRODUCTS_IN_WAREHOUSE)"
                clearable
                ref="warehouseSelectRef"
                infinite
                multiple
                @input="getProductItemsByFilter"
                @item-resolved="setWarehouse"
                @next-page-resolved="
                  (data) => setWarehouse([...warehouseList, ...data])
                "
                :get-item-promise="
                  ({ text, page }) =>
                    $store.dispatch('getWareHouses', {
                      page,
                      name: text,
                      limit: 15,
                    })
                "
                v-model="ourProductFilter.warehouseIds"
                :items="warehouseList"
                class="product-select-in-modal"
              ></vue-select>
            </template>
            <template #filter.productName>
              <div class="pa-1">
                <vue-select
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getProducts', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  @item-resolved="setProduct"
                  @next-page-resolved="
                    (data) => setProduct([...products, ...data])
                  "
                  :items="products"
                  v-model="ourProductFilter.productId"
                  @input="getProductItemsByFilter"
                  clearable
                  infinite
                  name="select_on_block"
                >
                  <template #option="{ item, searchText }">
                    <product-select-item
                      :name="item.name"
                      :attrs="item.attrs"
                      :search-text="searchText"
                    ></product-select-item>
                    <v-list-item-title>
                      <p class="ma-0">{{ item.name }}</p>
                      <span class="v-messages">{{
                        item.attrs.join(" && ")
                      }}</span>
                    </v-list-item-title>
                  </template>
                </vue-select>
              </div>
            </template>
            <template #item.action="{ item }">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    :to="{
                      name: 'product-history',
                      query: { qrCode: item.id },
                    }"
                    v-bind="attrs"
                    v-on="on"
                    class="btn_33 edit_btn"
                  >
                    <vue-icon icon="indexIcon"></vue-icon>
                  </VBtn>
                </template>
                <span>{{ $tc("productHistory", 1) }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    @click="printQr(item)"
                    v-bind="attrs"
                    v-on="on"
                    class="btn_33 plus_btn"
                  >
                    <vue-icon icon="printIcon"></vue-icon>
                  </VBtn>
                </template>
                <span>{{ $tc("printQrCode", 1) }}</span>
              </v-tooltip>
            </template>

            <template #item.stillageAddress="{ item }">
              {{ item.stillageAddress && item.stillageAddress.join(" ") }}
            </template>
            <template
              #item.orderedDepartmentsName="{
                /**
                 * @type Object
                 * @property orderedDepartmentsName {string}
                 */
                item,
              }"
            >
              {{
                item.orderedDepartmentsName &&
                item.orderedDepartmentsName.join(", ")
              }}
            </template>
            <template #item.carriageAddresses="{ item }">
              {{ item.carriageAddresses && item.carriageAddresses.join(" ") }}
            </template>
            <template #item.count="{ item }"
              >{{ item.count | numberParse }}
              {{ item[`unit_type_name_${$i18n.locale}`] }}
            </template>
            <template
              #item.partitionDate="{
                /**
                 * @type Object
                 * @property partitionDate {string}
                 */
                item,
              }"
              >{{ item.partitionDate | dateParse }}</template
            >
            <template #item.productAttrs="{ item }">
              {{ item.productAttrs.join(" || ") }}
            </template>
            <template
              #item.takenAwayDate="{
                /**
                 * @type Object
                 * @property takenAwayDate {string}
                 */
                item,
              }"
              >{{ item.takenAwayDate | fullTimeParse }}</template
            >
            <template #item.print="{ item }">
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    class="btn_33 plus_btn"
                    @click="printQr(item)"
                  >
                    <vue-icon
                      :height="15"
                      :width="15"
                      icon="printIcon"
                    ></vue-icon>
                  </VBtn>
                </template>
                <span>{{ $tc("printQrCode", 1) }}</span>
              </v-tooltip>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.pagination.limit = limit;
              configuration.pagination.page = 1;
              changePage();
            }
          "
          v-model="configuration.pagination.page"
          :length="lastPage"
          @input="changePage"
          go-to
          :limit="configuration.pagination.limit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  downloadBlobFile,
  makerPagination,
  queryToString,
  trueSet,
} from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { QrService } from "@/utils/QrService";
import { LotTemplate } from "@/utils/qr-template/LotTemplate";
import { ADDITIONAL_ROLES, PRODUCT_ITEM_STATUS } from "@/utils/constants";
import ProductSelectItem from "@/components/product/SelectItem.vue";

const FILE_TYPE = {
  excel: {
    ext: "xls",
    url: "reports/report-excel",
    type: "excel",
  },
};
export default {
  data() {
    return {
      departments: [],
      warehouseList: [],
      usersList: [],
      selectedItems: [],
      products: [],
      isShowFilter: false,
      ourProductFilter: {
        productId: null,
        orderNumb: null,
        contractNumb: null,
        takenAwayUserId: null,
        warehouseIds: [],
        orderedDepartmentId: null,
        accountingCode: null,
      },
      configuration: {
        pagination: {
          page: 1,
          limit: "10",
        },
        options: {
          sortBy: "takenAwayDate",
          sortDirection: false,
        },
      },
      lastPage: 0,
      items: [],
      headers: [
        { text: "product", value: "productName" },
        { text: "contractNumber", value: "contractCode" },
        { text: "attributes", value: "productAttrs" },
        { text: "productCode", value: "accountingCode" },
        { text: "count", value: "count" },
        { text: "warehouse", value: "warehouseName" },
        { text: "stillageAddress", value: "stillageAddress" },
        { text: "carriageAddress", value: "carriageAddresses" },
        { text: "print", value: "print" },
        { text: "dateAcceptance", value: "partitionDate" },
        // { text: "acceptUser", value: "takenAwayUser" },
        // { text: "gaveUser", value: "givenUser" },
        { value: "orderedDepartmentsName", text: "department" },
        { text: "ENV", value: "invNumber" },
      ],
    };
  },
  computed: {
    canChangeMaterial() {
      return this.$store.getters.additionalRoles.includes(
        ADDITIONAL_ROLES.SEE_ALL_PRODUCTS_IN_WAREHOUSE
      );
    },
    canMoveProduct() {
      return this.$can(this.$permissions["SEE_ALL_PRODUCTS_IN_WAREHOUSE"]);
    },
    headersWithTranslate() {
      return this.headers.map((item) => {
        return {
          text: this.$t(item.text),
          value: item.value,
        };
      });
    },
  },
  methods: {
    setDepartment(departments) {
      this.departments = departments;
    },
    setWarehouse(warehouses) {
      this.warehouseList = warehouses;
    },
    setProduct(products) {
      this.products = products;
    },
    setUser(users) {
      this.usersList = users;
    },
    trueSet,
    onUpdated() {
      this.getProductItemsByFilter();
      this.selectedItems = [];
    },
    /**
     * @typedef lotItem
     * @property {number} qrcode
     * @property {number} contractCode
     * @property {number} id
     * @param item {lotItem}
     * @returns {Promise<void>}
     */
    async printQr(item) {
      const qrService = new QrService();
      const qrTemplate = new LotTemplate();
      await qrTemplate.addQr(`{id: ${item.id}}`);
      qrTemplate.addText(`Id: ${item.qrcode}`);
      qrTemplate.addText(`Contract: ${item.contractCode}`);
      if (item.invNumber) {
        qrTemplate.addText(`Env: ${item.invNumber}`);
      }
      qrService.add(qrTemplate.data);
      qrService.show(item.name + "_qr");
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.push({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsByFilter() {
      if (this.ready) {
        this.showLoading();
        const { page } = this.configuration.pagination;
        if (page !== 1) {
          this.configuration.pagination.page = 1;
          await this.$router.push({ query: { page: `1` } });
        }
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsBySort() {
      this.showLoading();
      const { query: initialQuery } = this.$route;
      const query = {
        ...initialQuery,
        ...this.configuration.pagination,
        ...this.configuration.options,
      };
      try {
        await this.$router.push({ query });
      } catch (e) {
        console.error(e);
      }
      await this.getProductItems();
      this.clearLoading();
    },
    async getProductItems() {
      this.selectedItems = [];
      const { page, limit } = this.configuration.pagination;
      let params = {
        ...this.ourProductFilter,
        ...this.configuration.options,
        page: page - 1,
        limit,
        idSort: true,
        state: PRODUCT_ITEM_STATUS.PRODUCT_PRODUCED,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get(
          `product-item/my-ordered-products-in-warehouse${queryToString(
            params
          )}`
        );
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async downloadProductList() {
      try {
        this.showLoading();
        let department_id = this.$store.getters.user.department_id;
        let params = {
          link: "7bfh30",
          name: "Омборхоналар бўйича ТМБлар",
          columns: {
            product_name: {
              name: "product_name",
              title: "Маҳсулот номи",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            contract_code: {
              name: "contract_code",
              title: "Контракт",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            product_attribute: {
              name: "product_attribute",
              title: "Атрибутлар",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            accounting_code: {
              name: "accounting_code",
              title: "Код учета",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            soni: {
              name: "soni",
              title: "Миқдори",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            warehouse: {
              name: "warehouse",
              title: "Омборхона",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
            placed_date: {
              name: "placed_date",
              title: "Жойлаштирилган сана",
              type: "date",
              columnFormat: "date",
              customDateFormat: null,
              table: "report",
            },
            department_id: {
              name: "department_id",
              title: "department_id",
              type: "number",
              columnFormat: "number",
              customDateFormat: null,
              table: "report",
            },
            department_uz_name: {
              name: "department_uz_name",
              title: "Бўлим",
              type: "string",
              columnFormat: "string",
              customDateFormat: null,
              table: "report",
            },
          },
          selectedColumns: [
            "product_name",
            "contract_code",
            "product_attribute",
            "accounting_code",
            "soni",
            "warehouse",
            "placed_date",
            "department_uz_name",
          ],
          conditions: [
            {
              columnName: "department_id",
              type: "Equals",
              value: "52",
              id: null,
              order: 0,
            },
          ],
          criteriaPattern: `(${department_id})`,
          templateId: 4,
          sortColumn: null,
          sortColumnType: null,
          filter: {
            start: 0,
            size: 20,
            searchKey: "",
            valueMap: null,
            sortColumn: null,
            sortType: true,
          },
          description: "",
          folder: {
            valueMap: {
              CODE: "e1d1d6da-5dee-4110-9144-903c1c9eb403",
              name: "DEPARTMENT",
              description: "DEPARTMENT",
              id: "2",
              value: "2",
            },
          },
          deleted: false,
          templateName: "Омборхоналар бўйича ТМБлар",
          groupColumns: null,
          htmlTemplateId: 3,
          isExport: false,
        };
        let fileType = FILE_TYPE.excel.ext;
        const { data } = await this.$http.post("reports/report-excel", params, {
          responseType: "blob",
        });

        let blob = new Blob([data], { type: fileType });
        downloadBlobFile(blob, `product-list.${fileType}`);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    this.showLoading();
    try {
      const { page, sortBy, sortDesc } = this.$route.query;
      if (page) this.configuration.pagination.page = +page;
      if (sortBy) this.configuration.options.sortBy = sortBy;
      if (typeof sortDesc !== "undefined")
        this.configuration.options.sortDesc = trueSet(sortDesc);
      await this.getProductItems();
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
  components: {
    ProductSelectItem,
    VuePagination,
    VueSelect,
    TableWithFilter,
  },
};
</script>
